module.exports = {"title":"3D View","appearance":"Appearance","wireframe":"Wireframe","trimPlane":"Trim plane","planeOpacity":"Plane opacity","showIndicators":"Show indicators","resetCamera":"Reset camera"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/context/en/messages.json
// module id = 263
// module chunks = 0